import moment from 'moment';

export function getTimeTicksAndLocation(
  min: number,
  max: number,
  width: number
) {
  const diff = max - min;
  return getTimeTicks(min, max, width).map((item) => {
    const relativeStart = (item.timeStamp - min) / diff;
    return {
      ...item,
      pixelStart: width * relativeStart,
    };
  });
}

export const TICKS_DENSITY_PX = 80;
export function getTimeTicks(min: number, max: number, width: number) {
  const diff = max - min;
  const sections = Math.floor(width / TICKS_DENSITY_PX) + 1;

  const delta = diff / sections;
  const modeSelected = getModeShow(delta);

  const ticks: number[] = [];

  // find closer module
  let current = min;
  let rest = current % modeSelected.module;
  if (rest !== 0) {
    current = modeSelected.module - rest + current;
  }

  // Use time zone to use 00:00
  if (modeSelected.module > HOUR) {
    const minDate = moment.unix(current);
    const secondsMinDate = minDate.hours() * 60 * 60;
    rest = secondsMinDate % modeSelected.module;
    current = current - rest;
    if (current < min) {
      current += modeSelected.module;
    }
  }

  // Iterate to fill ticks
  while (current <= max) {
    ticks.push(current);
    current += modeSelected.module;
  }

  return ticks.map((tick, i, list) => ({
    timeStamp: tick,
    format: formatTick(modeSelected.module, tick, list[i - 1]),
  }));
}

function formatTick(module: number, tick: number, prevTick?: number) {
  const date = moment.unix(tick);
  const prevDate = prevTick && moment.unix(prevTick);

  // Seconds by default
  let dateFormat = 'LTS';
  const isMinutes = date.seconds() === 0;
  if (isMinutes) {
    dateFormat = 'LT';
  }
  const isDay =
    (date.hours() === 0 && date.minutes() === 0 && date.seconds() === 0) ||
    module >= DAY;
  if (isDay) {
    dateFormat = 'L';
  }

  // delta less a day and it has change of the day
  if (
    prevDate &&
    !isDay &&
    date.diff(prevDate, 'days') === 0 &&
    date.date() !== prevDate.date()
  ) {
    dateFormat = `${dateFormat}[\n]L`;
  }

  return date.format(dateFormat);
}

const SECOND = 1;
const MINUTE = SECOND * 60;
const HOUR = MINUTE * 60;
const DAY = HOUR * 24;
const WEEK = DAY * 7;

export const TIME_TICKS_MODE_SHOW = {
  SHOW_EACH_SECOND: { module: SECOND, mode: 'SHOW_EACH_SECOND' },
  SHOW_EACH_5_SECONDS: { module: SECOND * 5, mode: 'SHOW_EACH_5_SECONDS' },
  SHOW_EACH_15_SECONDS: { module: SECOND * 15, mode: 'SHOW_EACH_15_SECONDS' },
  SHOW_EACH_30_SECONDS: { module: SECOND * 30, mode: 'SHOW_EACH_30_SECONDS' },
  SHOW_EACH_MINUTE: { module: MINUTE, mode: 'SHOW_EACH_MINUTE' },
  SHOW_EACH_5_MINUTES: { module: MINUTE * 5, mode: 'SHOW_EACH_5_MINUTES' },
  SHOW_EACH_15_MINUTES: { module: MINUTE * 15, mode: 'SHOW_EACH_15_MINUTES' },
  SHOW_EACH_30_MINUTES: { module: MINUTE * 30, mode: 'SHOW_EACH_30_MINUTES' },
  SHOW_EACH_HOUR: { module: HOUR, mode: 'SHOW_EACH_HOUR' },
  SHOW_EACH_3_HOURS: { module: HOUR * 3, mode: 'SHOW_EACH_3_HOURS' },
  SHOW_EACH_6_HOURS: { module: HOUR * 6, mode: 'SHOW_EACH_6_HOURS' },
  SHOW_EACH_12_HOURS: { module: HOUR * 12, mode: 'SHOW_EACH_12_HOURS' },
  SHOW_EACH_DAY: { module: DAY, mode: 'SHOW_EACH_DAY' },
  SHOW_EACH_3_DAYS: { module: DAY * 3, mode: 'SHOW_EACH_3_DAYS' },
  SHOW_EACH_WEEK: { module: WEEK, mode: 'SHOW_EACH_WEEK' },
};

export function getModeShow(delta: number) {
  const modeSelected = Object.values(TIME_TICKS_MODE_SHOW).find(
    (mode, index, array) => delta < mode.module
  ) || { module: delta, mode: 'SHOW_DELTA' };
  return modeSelected;
}
